import { createApp } from "vue";
import { format } from "date-fns";

import Swal from "sweetalert2";

import { ZiggyVue } from "ziggy-js";
import { useFetch } from "@/components/useFetch.js";
import { Eventbus } from "@/components/eventbus.js";
import "@/xero-sync.js";
import DirectUpload from "@/components/directUpload.vue";
import DarkModeToggle from "@/components/darkModeToggle.vue";
import UsersList from "@/components/users/list.vue";
import CustomerList from "@/components/customers/list.vue";
import CustomerForm from "@/components/customers/form.vue";
import JobList from "@/components/jobs/list.vue";
import JobForm from "@/components/jobs/form.vue";
import QuoteList from "@/components/quotes/list.vue";
import QuoteForm from "@/components/quotes/form.vue";
import AddressAutocomplete from "@/components/addressAutocomplete.vue";
import AddressLocationPicker from "@/components/AddressLocationPicker.vue";
import GoogleMaps from "@/components/GoogleMaps.vue";
import QuotesGraph from "@/components/dashboard/QuotesGraph.vue";
import SettingsForm from "@/components/settings/form.vue";
import InvoicesList from "@/components/invoices/list.vue";
import InvoicesForm from "@/components/invoices/form.vue";

window.Swal = Swal;
window.useFetch = useFetch;

const components = {
  "dark-mode-toggle": DarkModeToggle,
  "direct-upload": DirectUpload,
  "users-list": UsersList,
  "customers-list": CustomerList,
  "customers-form": CustomerForm,
  "jobs-list": JobList,
  "jobs-form": JobForm,
  "quotes-list": QuoteList,
  "quotes-form": QuoteForm,
  "address-autocomplete": AddressAutocomplete,
  "address-location-picker": AddressLocationPicker,
  "google-maps": GoogleMaps,
  "quotes-graph": QuotesGraph,
  "settings-form": SettingsForm,
  "invoices-list": InvoicesList,
  "invoices-form": InvoicesForm,
};

let n = 0;
for (const tag in components) {
  for (const el of document.querySelectorAll(tag)) {
    const app = createApp({
      name: `${tag} ${++n}`,
      template: el.outerHTML,
    });
    app.component(tag, components[tag]);
    app.use(ZiggyVue);
    app.mount(el);
    app.config.globalProperties.$formatDate = (date) => {
      return format(new Date(date), "dd MMMM yyyy");
    };
    app.config.globalProperties.$formatDateTime = (date) => {
      return format(new Date(date), "dd MMMM yyyy HH:mm");
    };
  }
}

window.document
  .querySelector("#main-container")
  ?.addEventListener("click", (e) => {
    const button = e.target;
    if (e.target.classList.contains("js-confirmDelete")) {
      const deleteText = button.getAttribute("data-delete-text");

      confirmHandler(
        "Delete",
        deleteText,
        "Do you want to delete this?",
        "delete",
        button.getAttribute("data-delete-href"),
        "Deleted",
        button.getAttribute("data-delete-then"),
        true
      );
    }
  });

let confirmHandler = async function (
  confirmButton,
  confirmDetails,
  confirmQuestion,
  fetchAction,
  requestHref,
  successTitle,
  successEmit,
  isTable
) {
  const result = await Swal.fire({
    title: confirmQuestion,
    html: confirmDetails,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: confirmButton,
    customClass: {
      confirmButton: "bg-danger",
    },
    reverseButtons: true,
    focusConfirm: false,
  });

  if (!result.isConfirmed) {
    return;
  }

  const response = await useFetch(requestHref, {
    method: fetchAction,
  });

  if (!response.ok) {
    alert("System error");
    criteria.loading = false;
  }

  const data = await response.json();

  if (data?.message.type === "error") {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: data.message.title,
      customClass: {
        confirmButton: "bg-danger",
      },
      showConfirmButton: true,
    });
  } else {
    Swal.fire({
      icon: "success",
      title: successTitle,
      timer: 1500,
      timerProgressBar: true,
      showConfirmButton: false,
    }).then(() => {
      if (isTable === false) {
        location.reload();
      } else if (successEmit) {
        Eventbus.emit(successEmit);
      }
    });
  }
};

let tabButtons = document.querySelectorAll(".nav-link[data-bs-target]");
if (tabButtons.length) {
  for (let tabButton of tabButtons) {
    tabButton.addEventListener("show.bs.tab", function (ev) {
      window.location.hash = ev.target.getAttribute("data-bs-target");
    });

    // don't think I like this
    // if (tabButton.classList.contains('active')) {
    //     window.location.hash = tabButton.getAttribute('data-bs-target');
    // }
  }

  window.onpopstate = goToTabFromHash;
}
